// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Desktop inbox as a dense table (>=1024px). Receptor tokens only: flat
   surfaces, hairline rules, no shadows. Mobile keeps the card list. */
@media (min-width: 1024px) {
  .sol--table {
    width: 100%;
    max-width: var(--receptor-page-max, 1200px);
    margin: 0 auto;
    background: transparent;
  }

  .sol--table .sol-head {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 24px;
    padding: 8px 0 20px;
  }

  .sol--table .sol-title {
    font-size: var(--fs-h2);
    font-weight: 300;
    margin-right: auto;
  }

  .sol--table .sol-count {
    flex-basis: 100%;
    order: 3;
  }

  .sol--table .sol-empty {
    flex: 0 0 auto;
    border: 1px solid var(--rule);
    background: var(--surface);
  }

  .sol-table__tools {
    display: flex;
    margin-bottom: 12px;
  }

  .sol-table__tools .search {
    width: 100%;
    max-width: 420px;
  }

  .sol-table__wrap {
    background: var(--surface);
  }

  .sol-table__tbl tbody tr:hover {
    background: var(--signal-soft);
  }

  .sol-table__tbl td {
    height: 56px;
  }

  .sol-table__party {
    display: block;
    font-size: var(--fs-body);
    color: var(--ink);
    text-decoration: none;
  }

  .sol-table__party:hover {
    color: var(--signal-deep);
  }

  .sol-table__party:focus-visible {
    outline: 2px solid var(--signal);
    outline-offset: 2px;
  }

  .sol-table__plain {
    font-size: var(--fs-ui);
    font-weight: 400;
    color: var(--ink-2);
  }

  .sol-table__due {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--ink-2);
    font-size: var(--fs-ui);
    white-space: nowrap;
  }

  .sol-table__pill {
    font-family: var(--font-mono);
    font-size: var(--fs-micro);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    border: 1px solid var(--cream-deep);
    color: var(--cream-deep);
    padding: 2px 6px;
  }

  .sol-table__state {
    font-family: var(--font-mono);
    font-size: var(--fs-meta);
    color: var(--ink);
    white-space: nowrap;
  }

  .sol-table__caption {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/solicitudes/SolicitudesTable.css"],"names":[],"mappings":"AAAA;sEACsE;AACtE;EACE;IACE,WAAW;IACX,2CAA2C;IAC3C,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,mCAAmC;IACnC,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;AACF","sourcesContent":["/* Desktop inbox as a dense table (>=1024px). Receptor tokens only: flat\n   surfaces, hairline rules, no shadows. Mobile keeps the card list. */\n@media (min-width: 1024px) {\n  .sol--table {\n    width: 100%;\n    max-width: var(--receptor-page-max, 1200px);\n    margin: 0 auto;\n    background: transparent;\n  }\n\n  .sol--table .sol-head {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px 24px;\n    padding: 8px 0 20px;\n  }\n\n  .sol--table .sol-title {\n    font-size: var(--fs-h2);\n    font-weight: 300;\n    margin-right: auto;\n  }\n\n  .sol--table .sol-count {\n    flex-basis: 100%;\n    order: 3;\n  }\n\n  .sol--table .sol-empty {\n    flex: 0 0 auto;\n    border: 1px solid var(--rule);\n    background: var(--surface);\n  }\n\n  .sol-table__tools {\n    display: flex;\n    margin-bottom: 12px;\n  }\n\n  .sol-table__tools .search {\n    width: 100%;\n    max-width: 420px;\n  }\n\n  .sol-table__wrap {\n    background: var(--surface);\n  }\n\n  .sol-table__tbl tbody tr:hover {\n    background: var(--signal-soft);\n  }\n\n  .sol-table__tbl td {\n    height: 56px;\n  }\n\n  .sol-table__party {\n    display: block;\n    font-size: var(--fs-body);\n    color: var(--ink);\n    text-decoration: none;\n  }\n\n  .sol-table__party:hover {\n    color: var(--signal-deep);\n  }\n\n  .sol-table__party:focus-visible {\n    outline: 2px solid var(--signal);\n    outline-offset: 2px;\n  }\n\n  .sol-table__plain {\n    font-size: var(--fs-ui);\n    font-weight: 400;\n    color: var(--ink-2);\n  }\n\n  .sol-table__due {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--ink-2);\n    font-size: var(--fs-ui);\n    white-space: nowrap;\n  }\n\n  .sol-table__pill {\n    font-family: var(--font-mono);\n    font-size: var(--fs-micro);\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    border: 1px solid var(--cream-deep);\n    color: var(--cream-deep);\n    padding: 2px 6px;\n  }\n\n  .sol-table__state {\n    font-family: var(--font-mono);\n    font-size: var(--fs-meta);\n    color: var(--ink);\n    white-space: nowrap;\n  }\n\n  .sol-table__caption {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
